import LocationSearch from "./LocationSearch";
import SlideImages from "./SlideImages";
import ContactPage from "./ContactPage";
import SlideImageHome from "./SlideImageHome";
import SlideImagesLazy from "./SlideImagesLazy";
import SlideImagesFullScreen from "./SlideImagesFullScreen";
import MoreInfoForm from "./MoreInfoForm";
import Whatsapp from "./Whatsapp";
import LGPD from "./LGPD";
import Popup from "./Popup";
import RegisterPropertyPage from "./RegisterPropertyPage";
import SlideHome from "./SlideHome";
import SlideCards from "./SlideCards";
import FixedModal from "./FixedModal";
import LazyLoadImage from "./LazyLoadImage";
import SliderYoutubeBackground from "./SliderYoutubeBackground";
import SlideImages2 from "./SlideImages2";
import SlideImages3 from "./SlideImages3";
import SlideImagesFullScreen2 from "./SlideImagesFullScreen2";
import SlideImagesFullScreen3 from "./SlideImagesFullScreen3";
import SlideHomeBlur from "./SlideHomeBlur";
import CadastroCorretorPage from "./CadastroCorretorPage";
import MiniCalendar from "./MiniCalendar";
export default {
    LocationSearch: LocationSearch,
    SlideImages: SlideImages,
    ContactPage: ContactPage,
    SlideImageHome: SlideImageHome,
    SlideImagesLazy: SlideImagesLazy,
    SlideImagesFullScreen: SlideImagesFullScreen,
    MoreInfoForm: MoreInfoForm,
    SliderYoutubeBackground: SliderYoutubeBackground,
    Whatsapp: Whatsapp,
    LazyLoadImage: LazyLoadImage,
    Popup: Popup,
    SlideHomeBlur: SlideHomeBlur,
    RegisterPropertyPage: RegisterPropertyPage,
    SlideHome: SlideHome,
    SlideCards: SlideCards,
    FixedModal: FixedModal,
    SlideImages2: SlideImages2,
    SlideImages3: SlideImages3,
    CadastroCorretorPage: CadastroCorretorPage,
    SlideImagesFullScreen2: SlideImagesFullScreen2,
    SlideImagesFullScreen3: SlideImagesFullScreen3,
    Lgpd: LGPD,
    MiniCalendar: MiniCalendar,
};
